export const WebUiMarketingInvestEnI18n = {
    section0: {
        icons: [`point`, `point`, `point`, `point`, `point`, `point`],
    },
};
